import * as React from 'react';
import { Countdown } from 'components/Countdown';
import { withInjectedRootStore, RootStore } from 'providers';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import { Country } from 'enums';
import s from './SaleBanner.scss';
import dayjs from 'dayjs';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';
import { useMemo } from 'react';

interface LastDaySaleBannerContentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const LastDaySaleBannerContentComp: React.FunctionComponent<
  LastDaySaleBannerContentProps
> = ({ rootStore }) => {
  const { country } = rootStore.appStore.appContext;
  const { saleEndDate, currentDateUtc, discountPercent } =
    rootStore.appStore.appContext.saleParams;

  const endDate = useMemo(() => {
    let calculatedEndDate = saleEndDate;
    if (country === Country.USA || country === Country.CA) {
      calculatedEndDate = +dayjs(calculatedEndDate).subtract(1, 'minute');
    }
    return calculatedEndDate;
  }, [country, saleEndDate]);

  return (
    <Box
      dataHook='last-day-sale-banner-content'
      align='center'
      verticalAlign='middle'
    >
      <Text dataHook='last-day-sale-text' size='small'>
        <Trans
          i18nKey={'premium-purchase-plan.studio_sale.last_day_countdown.header.strip'}
          values={{ percent: discountPercent || '50' }}
        >
          <Text weight='bold'>
            Save {{ percent: discountPercent || '50' }}%
          </Text>
          rest
        </Trans>
      </Text>
      <Box paddingLeft='34px' paddingRight='15px' opacity='0.2'>
        <Text>|</Text>
      </Box>
      {endDate && (
        <Box marginLeft='SP1' marginBottom='2px'>
          <Countdown
            currentDate={currentDateUtc}
            endDate={endDate}
            classNames={{
              wrapper: s.countdown,
              timePart: s.studioTimePart,
              label: s.countdownTimePartLabel,
              separator: s.countdownSeparator,
              timePartWrapper: s.countdownTimePartWrapper,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export const LastDaySaleBannerContent = withInjectedRootStore(
  withExperiments(LastDaySaleBannerContentComp),
);
